import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "pagination-container",
  "aria-label": "row pagination"
}
const _hoisted_2 = {
  key: 0,
  "aria-label": "Page navigation"
}
const _hoisted_3 = { class: "pagination justify-content-center" }
const _hoisted_4 = { class: "page-item" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "page-item" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.totalPages >= 1)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_2, [
          _createElementVNode("ul", _hoisted_3, [
            _createElementVNode("li", _hoisted_4, [
              _createElementVNode("a", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.prev())),
                class: "page-link",
                "aria-label": "Previous"
              }, _hoisted_6)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.range, (page, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                onClick: ($event: any) => (_ctx.onClick(page)),
                class: "page-item"
              }, [
                _createElementVNode("a", {
                  class: _normalizeClass([{'active': page === _ctx.currentPage}, "page-link"])
                }, _toDisplayString(page), 3)
              ], 8, _hoisted_7))
            }), 128)),
            _createElementVNode("li", _hoisted_8, [
              _createElementVNode("a", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.next())),
                class: "page-link",
                "aria-label": "Next"
              }, _hoisted_10)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}